/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Faceta API
 * API мультитенантного admin-движка Faceta. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateInputBody,
  ErrorModel,
  MyTenantsOutputBody,
  TenantBody,
  TenantListBody,
  TenantsListParams,
  TenantsUpdateHeaders,
  UpdateInputBody
} from '../model';

import { facetaFetch } from '../../http';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type tenantsMineResponse200 = {
  data: MyTenantsOutputBody
  status: 200
}

export type tenantsMineResponse401 = {
  data: ErrorModel
  status: 401
}

export type tenantsMineResponse500 = {
  data: ErrorModel
  status: 500
}

export type tenantsMineResponseSuccess = (tenantsMineResponse200) & {
  headers: Headers;
};
export type tenantsMineResponseError = (tenantsMineResponse401 | tenantsMineResponse500) & {
  headers: Headers;
};

export type tenantsMineResponse = (tenantsMineResponseSuccess | tenantsMineResponseError)

export const getTenantsMineUrl = () => {




  return `/me/tenants`
}

/**
 * Тенанты, к которым у спрашивающего есть доступ. Владелец платформы получает все. Страниц нет: человек состоит в считаном числе тенантов, и постраничная выдача здесь только мешала бы.
 *
 * Отдельно от общего списка, потому что общий доступен лишь владельцу платформы: без этой операции администратор тенанта не смог бы даже завести сайт — форме нужен список тенантов, а он ему закрыт.
 * @summary Мои тенанты
 */
export const tenantsMine = async ( options?: Parameters<typeof facetaFetch>[1]): Promise<tenantsMineResponse> => {

  return facetaFetch<tenantsMineResponse>(getTenantsMineUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTenantsMineQueryKey = () => {
    return [
    `/me/tenants`
    ] as const;
    }


export const getTenantsMineQueryOptions = <TData = Awaited<ReturnType<typeof tenantsMine>>, TError = ErrorModel>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsMine>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTenantsMineQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantsMine>>> = ({ signal }) => tenantsMine({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tenantsMine>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TenantsMineQueryResult = NonNullable<Awaited<ReturnType<typeof tenantsMine>>>
export type TenantsMineQueryError = ErrorModel


export function useTenantsMine<TData = Awaited<ReturnType<typeof tenantsMine>>, TError = ErrorModel>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsMine>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantsMine>>,
          TError,
          Awaited<ReturnType<typeof tenantsMine>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantsMine<TData = Awaited<ReturnType<typeof tenantsMine>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsMine>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantsMine>>,
          TError,
          Awaited<ReturnType<typeof tenantsMine>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantsMine<TData = Awaited<ReturnType<typeof tenantsMine>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsMine>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Мои тенанты
 */

export function useTenantsMine<TData = Awaited<ReturnType<typeof tenantsMine>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsMine>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTenantsMineQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type tenantsListResponse200 = {
  data: TenantListBody
  status: 200
}

export type tenantsListResponse401 = {
  data: ErrorModel
  status: 401
}

export type tenantsListResponse403 = {
  data: ErrorModel
  status: 403
}

export type tenantsListResponse422 = {
  data: ErrorModel
  status: 422
}

export type tenantsListResponse500 = {
  data: ErrorModel
  status: 500
}

export type tenantsListResponseSuccess = (tenantsListResponse200) & {
  headers: Headers;
};
export type tenantsListResponseError = (tenantsListResponse401 | tenantsListResponse403 | tenantsListResponse422 | tenantsListResponse500) & {
  headers: Headers;
};

export type tenantsListResponse = (tenantsListResponseSuccess | tenantsListResponseError)

export const getTenantsListUrl = (params?: TenantsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/tenants?${stringifiedParams}` : `/tenants`
}

/**
 * Отдаёт страницу списка и общее число подходящих записей. Параметр deleted переключает выдачу на корзину: удалённые не смешиваются с живыми, потому что половина действий над ними бессмысленна.
 * @summary Список тенантов
 */
export const tenantsList = async (params?: TenantsListParams, options?: Parameters<typeof facetaFetch>[1]): Promise<tenantsListResponse> => {

  return facetaFetch<tenantsListResponse>(getTenantsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTenantsListQueryKey = (params?: TenantsListParams,) => {
    return [
    `/tenants`, ...(params ? [params] : [])
    ] as const;
    }


export const getTenantsListQueryOptions = <TData = Awaited<ReturnType<typeof tenantsList>>, TError = ErrorModel>(params?: TenantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTenantsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantsList>>> = ({ signal }) => tenantsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tenantsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TenantsListQueryResult = NonNullable<Awaited<ReturnType<typeof tenantsList>>>
export type TenantsListQueryError = ErrorModel


export function useTenantsList<TData = Awaited<ReturnType<typeof tenantsList>>, TError = ErrorModel>(
 params: undefined |  TenantsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantsList>>,
          TError,
          Awaited<ReturnType<typeof tenantsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantsList<TData = Awaited<ReturnType<typeof tenantsList>>, TError = ErrorModel>(
 params?: TenantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantsList>>,
          TError,
          Awaited<ReturnType<typeof tenantsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantsList<TData = Awaited<ReturnType<typeof tenantsList>>, TError = ErrorModel>(
 params?: TenantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Список тенантов
 */

export function useTenantsList<TData = Awaited<ReturnType<typeof tenantsList>>, TError = ErrorModel>(
 params?: TenantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTenantsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type tenantsCreateResponse201 = {
  data: TenantBody
  status: 201
}

export type tenantsCreateResponse401 = {
  data: ErrorModel
  status: 401
}

export type tenantsCreateResponse403 = {
  data: ErrorModel
  status: 403
}

export type tenantsCreateResponse404 = {
  data: ErrorModel
  status: 404
}

export type tenantsCreateResponse409 = {
  data: ErrorModel
  status: 409
}

export type tenantsCreateResponse422 = {
  data: ErrorModel
  status: 422
}

export type tenantsCreateResponse500 = {
  data: ErrorModel
  status: 500
}

export type tenantsCreateResponseSuccess = (tenantsCreateResponse201) & {
  headers: Headers;
};
export type tenantsCreateResponseError = (tenantsCreateResponse401 | tenantsCreateResponse403 | tenantsCreateResponse404 | tenantsCreateResponse409 | tenantsCreateResponse422 | tenantsCreateResponse500) & {
  headers: Headers;
};

export type tenantsCreateResponse = (tenantsCreateResponseSuccess | tenantsCreateResponseError)

export const getTenantsCreateUrl = () => {




  return `/tenants`
}

/**
 * Короткое имя должно быть свободно среди живых тенантов.
 * @summary Завести тенанта
 */
export const tenantsCreate = async (createInputBody: NonReadonly<CreateInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<tenantsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<tenantsCreateResponse>(getTenantsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createInputBody)
  }
);}





export const getTenantsCreateQueryKey = (createInputBody?: NonReadonly<CreateInputBody>,) => {
    return [
    'POST', `/tenants`, createInputBody
    ] as const;
    }


export const getTenantsCreateQueryOptions = <TData = Awaited<ReturnType<typeof tenantsCreate>>, TError = ErrorModel>(createInputBody: NonReadonly<CreateInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTenantsCreateQueryKey(createInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantsCreate>>> = ({ signal }) => tenantsCreate(createInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tenantsCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TenantsCreateQueryResult = NonNullable<Awaited<ReturnType<typeof tenantsCreate>>>
export type TenantsCreateQueryError = ErrorModel


export function useTenantsCreate<TData = Awaited<ReturnType<typeof tenantsCreate>>, TError = ErrorModel>(
 createInputBody: NonReadonly<CreateInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantsCreate>>,
          TError,
          Awaited<ReturnType<typeof tenantsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantsCreate<TData = Awaited<ReturnType<typeof tenantsCreate>>, TError = ErrorModel>(
 createInputBody: NonReadonly<CreateInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantsCreate>>,
          TError,
          Awaited<ReturnType<typeof tenantsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantsCreate<TData = Awaited<ReturnType<typeof tenantsCreate>>, TError = ErrorModel>(
 createInputBody: NonReadonly<CreateInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Завести тенанта
 */

export function useTenantsCreate<TData = Awaited<ReturnType<typeof tenantsCreate>>, TError = ErrorModel>(
 createInputBody: NonReadonly<CreateInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTenantsCreateQueryOptions(createInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type tenantsDeleteResponse204 = {
  data: void
  status: 204
}

export type tenantsDeleteResponse401 = {
  data: ErrorModel
  status: 401
}

export type tenantsDeleteResponse403 = {
  data: ErrorModel
  status: 403
}

export type tenantsDeleteResponse404 = {
  data: ErrorModel
  status: 404
}

export type tenantsDeleteResponse422 = {
  data: ErrorModel
  status: 422
}

export type tenantsDeleteResponse500 = {
  data: ErrorModel
  status: 500
}

export type tenantsDeleteResponseSuccess = (tenantsDeleteResponse204) & {
  headers: Headers;
};
export type tenantsDeleteResponseError = (tenantsDeleteResponse401 | tenantsDeleteResponse403 | tenantsDeleteResponse404 | tenantsDeleteResponse422 | tenantsDeleteResponse500) & {
  headers: Headers;
};

export type tenantsDeleteResponse = (tenantsDeleteResponseSuccess | tenantsDeleteResponseError)

export const getTenantsDeleteUrl = (id: string,) => {




  return `/tenants/${id}`
}

/**
 * Отправляет тенанта в корзину. Данные остаются в базе, восстановить можно операцией восстановления.
 * @summary Удалить тенанта
 */
export const tenantsDelete = async (id: string, options?: Parameters<typeof facetaFetch>[1]): Promise<tenantsDeleteResponse> => {

  return facetaFetch<tenantsDeleteResponse>(getTenantsDeleteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTenantsDeleteQueryKey = (id: string,) => {
    return [
    'DELETE', `/tenants/${id}`
    ] as const;
    }


export const getTenantsDeleteQueryOptions = <TData = Awaited<ReturnType<typeof tenantsDelete>>, TError = ErrorModel>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTenantsDeleteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantsDelete>>> = ({ signal }) => tenantsDelete(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tenantsDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TenantsDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof tenantsDelete>>>
export type TenantsDeleteQueryError = ErrorModel


export function useTenantsDelete<TData = Awaited<ReturnType<typeof tenantsDelete>>, TError = ErrorModel>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantsDelete>>,
          TError,
          Awaited<ReturnType<typeof tenantsDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantsDelete<TData = Awaited<ReturnType<typeof tenantsDelete>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantsDelete>>,
          TError,
          Awaited<ReturnType<typeof tenantsDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantsDelete<TData = Awaited<ReturnType<typeof tenantsDelete>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Удалить тенанта
 */

export function useTenantsDelete<TData = Awaited<ReturnType<typeof tenantsDelete>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTenantsDeleteQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type tenantsGetResponse200 = {
  data: TenantBody
  status: 200
}

export type tenantsGetResponse401 = {
  data: ErrorModel
  status: 401
}

export type tenantsGetResponse403 = {
  data: ErrorModel
  status: 403
}

export type tenantsGetResponse404 = {
  data: ErrorModel
  status: 404
}

export type tenantsGetResponse422 = {
  data: ErrorModel
  status: 422
}

export type tenantsGetResponse500 = {
  data: ErrorModel
  status: 500
}

export type tenantsGetResponseSuccess = (tenantsGetResponse200) & {
  headers: Headers;
};
export type tenantsGetResponseError = (tenantsGetResponse401 | tenantsGetResponse403 | tenantsGetResponse404 | tenantsGetResponse422 | tenantsGetResponse500) & {
  headers: Headers;
};

export type tenantsGetResponse = (tenantsGetResponseSuccess | tenantsGetResponseError)

export const getTenantsGetUrl = (id: string,) => {




  return `/tenants/${id}`
}

/**
 * Возвращает и удалённого: его карточку открывают, чтобы восстановить.
 * @summary Один тенант
 */
export const tenantsGet = async (id: string, options?: Parameters<typeof facetaFetch>[1]): Promise<tenantsGetResponse> => {

  return facetaFetch<tenantsGetResponse>(getTenantsGetUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTenantsGetQueryKey = (id: string,) => {
    return [
    `/tenants/${id}`
    ] as const;
    }


export const getTenantsGetQueryOptions = <TData = Awaited<ReturnType<typeof tenantsGet>>, TError = ErrorModel>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTenantsGetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantsGet>>> = ({ signal }) => tenantsGet(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tenantsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TenantsGetQueryResult = NonNullable<Awaited<ReturnType<typeof tenantsGet>>>
export type TenantsGetQueryError = ErrorModel


export function useTenantsGet<TData = Awaited<ReturnType<typeof tenantsGet>>, TError = ErrorModel>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantsGet>>,
          TError,
          Awaited<ReturnType<typeof tenantsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantsGet<TData = Awaited<ReturnType<typeof tenantsGet>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantsGet>>,
          TError,
          Awaited<ReturnType<typeof tenantsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantsGet<TData = Awaited<ReturnType<typeof tenantsGet>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Один тенант
 */

export function useTenantsGet<TData = Awaited<ReturnType<typeof tenantsGet>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTenantsGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type tenantsUpdateResponse200 = {
  data: TenantBody
  status: 200
}

export type tenantsUpdateResponse401 = {
  data: ErrorModel
  status: 401
}

export type tenantsUpdateResponse403 = {
  data: ErrorModel
  status: 403
}

export type tenantsUpdateResponse404 = {
  data: ErrorModel
  status: 404
}

export type tenantsUpdateResponse409 = {
  data: ErrorModel
  status: 409
}

export type tenantsUpdateResponse422 = {
  data: ErrorModel
  status: 422
}

export type tenantsUpdateResponse500 = {
  data: ErrorModel
  status: 500
}

export type tenantsUpdateResponseSuccess = (tenantsUpdateResponse200) & {
  headers: Headers;
};
export type tenantsUpdateResponseError = (tenantsUpdateResponse401 | tenantsUpdateResponse403 | tenantsUpdateResponse404 | tenantsUpdateResponse409 | tenantsUpdateResponse422 | tenantsUpdateResponse500) & {
  headers: Headers;
};

export type tenantsUpdateResponse = (tenantsUpdateResponseSuccess | tenantsUpdateResponseError)

export const getTenantsUpdateUrl = (id: string,) => {




  return `/tenants/${id}`
}

/**
 * Меняет только переданные поля.
 * @summary Изменить тенанта
 */
export const tenantsUpdate = async (id: string,
    updateInputBody: NonReadonly<UpdateInputBody>,
    headers: TenantsUpdateHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<tenantsUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<tenantsUpdateResponse>(getTenantsUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(updateInputBody)
  }
);}





export const getTenantsUpdateQueryKey = (id: string,
    updateInputBody?: NonReadonly<UpdateInputBody>,) => {
    return [
    'PATCH', `/tenants/${id}`, updateInputBody
    ] as const;
    }


export const getTenantsUpdateQueryOptions = <TData = Awaited<ReturnType<typeof tenantsUpdate>>, TError = ErrorModel>(id: string,
    updateInputBody: NonReadonly<UpdateInputBody>,
    headers: TenantsUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTenantsUpdateQueryKey(id,updateInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantsUpdate>>> = ({ signal }) => tenantsUpdate(id,updateInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tenantsUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TenantsUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof tenantsUpdate>>>
export type TenantsUpdateQueryError = ErrorModel


export function useTenantsUpdate<TData = Awaited<ReturnType<typeof tenantsUpdate>>, TError = ErrorModel>(
 id: string,
    updateInputBody: NonReadonly<UpdateInputBody>,
    headers: TenantsUpdateHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantsUpdate>>,
          TError,
          Awaited<ReturnType<typeof tenantsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantsUpdate<TData = Awaited<ReturnType<typeof tenantsUpdate>>, TError = ErrorModel>(
 id: string,
    updateInputBody: NonReadonly<UpdateInputBody>,
    headers: TenantsUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantsUpdate>>,
          TError,
          Awaited<ReturnType<typeof tenantsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantsUpdate<TData = Awaited<ReturnType<typeof tenantsUpdate>>, TError = ErrorModel>(
 id: string,
    updateInputBody: NonReadonly<UpdateInputBody>,
    headers: TenantsUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Изменить тенанта
 */

export function useTenantsUpdate<TData = Awaited<ReturnType<typeof tenantsUpdate>>, TError = ErrorModel>(
 id: string,
    updateInputBody: NonReadonly<UpdateInputBody>,
    headers: TenantsUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTenantsUpdateQueryOptions(id,updateInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type tenantsRestoreResponse200 = {
  data: TenantBody
  status: 200
}

export type tenantsRestoreResponse401 = {
  data: ErrorModel
  status: 401
}

export type tenantsRestoreResponse403 = {
  data: ErrorModel
  status: 403
}

export type tenantsRestoreResponse404 = {
  data: ErrorModel
  status: 404
}

export type tenantsRestoreResponse409 = {
  data: ErrorModel
  status: 409
}

export type tenantsRestoreResponse422 = {
  data: ErrorModel
  status: 422
}

export type tenantsRestoreResponse500 = {
  data: ErrorModel
  status: 500
}

export type tenantsRestoreResponseSuccess = (tenantsRestoreResponse200) & {
  headers: Headers;
};
export type tenantsRestoreResponseError = (tenantsRestoreResponse401 | tenantsRestoreResponse403 | tenantsRestoreResponse404 | tenantsRestoreResponse409 | tenantsRestoreResponse422 | tenantsRestoreResponse500) & {
  headers: Headers;
};

export type tenantsRestoreResponse = (tenantsRestoreResponseSuccess | tenantsRestoreResponseError)

export const getTenantsRestoreUrl = (id: string,) => {




  return `/tenants/${id}/restore`
}

/**
 * Возвращает тенанта из корзины. Отвечает 409, если его короткое имя за это время занял кто-то другой: уникальность проверяется только среди живых.
 * @summary Восстановить тенанта
 */
export const tenantsRestore = async (id: string, options?: Parameters<typeof facetaFetch>[1]): Promise<tenantsRestoreResponse> => {

  return facetaFetch<tenantsRestoreResponse>(getTenantsRestoreUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getTenantsRestoreQueryKey = (id: string,) => {
    return [
    'POST', `/tenants/${id}/restore`
    ] as const;
    }


export const getTenantsRestoreQueryOptions = <TData = Awaited<ReturnType<typeof tenantsRestore>>, TError = ErrorModel>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTenantsRestoreQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantsRestore>>> = ({ signal }) => tenantsRestore(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tenantsRestore>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TenantsRestoreQueryResult = NonNullable<Awaited<ReturnType<typeof tenantsRestore>>>
export type TenantsRestoreQueryError = ErrorModel


export function useTenantsRestore<TData = Awaited<ReturnType<typeof tenantsRestore>>, TError = ErrorModel>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsRestore>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantsRestore>>,
          TError,
          Awaited<ReturnType<typeof tenantsRestore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantsRestore<TData = Awaited<ReturnType<typeof tenantsRestore>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsRestore>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantsRestore>>,
          TError,
          Awaited<ReturnType<typeof tenantsRestore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantsRestore<TData = Awaited<ReturnType<typeof tenantsRestore>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Восстановить тенанта
 */

export function useTenantsRestore<TData = Awaited<ReturnType<typeof tenantsRestore>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantsRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTenantsRestoreQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






